<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title primary-title text-sm-center>
            <v-flex xs12>
              <h1 class="headline mb-0 text-sm-center text-xs-center text-lg-center">{{ championship.name }}</h1>
            </v-flex>
            <v-flex xs12>
              <h2 class="mb-0 text-sm-center text-xs-center text-lg-center">Team registration</h2>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 lg4>
                Team:
                <strong class="blue--text">{{ identity.displayName }}</strong>
              </v-flex>
              <v-flex xs12 sm6 md4 lg4>
                Team Category:
                <strong class="blue--text">{{ championship.genderCategory }}</strong>
              </v-flex>
              <v-flex xs12 sm6 md4 lg4>
                Championship Category:
                <strong class="blue--text">{{ championship.ageCategory }}</strong>
              </v-flex>
              <v-flex xs12 sm6 md4 lg4>
                <v-text-field v-model="team.coach" label="Coach" />
              </v-flex>
              <v-flex xs12 sm6 md4 lg4>
                <v-text-field v-model="team.manager" label="Manager" />
              </v-flex>
              <v-flex xs12 sm6 md4 lg4>
                <v-text-field v-model="team.memo" label="Remarks" />
              </v-flex>
              <v-flex xs12 sm6 md4 lg4>
                <v-text-field v-model="team.coachMobile" label="Coach's Contact No" />
              </v-flex>
              <v-flex xs12 sm6 md4 lg4>
                <v-text-field v-model="team.managerMobile" label="Manager's Contact No" />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex xs12 sm6 md4 lg4>
                <v-btn @click="cancel">Back to Championships</v-btn>
                <v-btn @click.prevent="save" color="success">{{ team.id ? "Update Team Details" : "Register team" }}</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="!ui.loading">
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 lg6 v-for="(player, index) in team.players" :key="index">
            <player-card :reg-no.sync="team.players[index].number" :jersey-no.sync="team.players[index].jerseyNo" :filter-category="team.category" :show-jersey-validation="ui.showJerseyError"></player-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-if="ui.loading">
        <v-card>
          <v-card-text>
            <v-flex>
              <div class="text-xs-center pa-3">
                <v-progress-circular indeterminate color="green"></v-progress-circular>
              </div>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-dialog ref="rcdialog" v-model="ui.showConfirm" lazy full-width width="50%">
          <v-card>
            <v-card-title class="headline">Are you sure?</v-card-title>

            <v-card-text>There are unsaved changes which will be lost if you leave this page. Are you sure you want to go back to team list?</v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="green darken-1" flat="flat" @click="ui.showConfirm = false">Cancel</v-btn>

              <v-btn color="green darken-1" flat="flat" @click="showChampList">Yes, show Team list</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar auto-height v-model="ui.showFeedback" :color="ui.isError ? 'error' : 'info'" :timeout="5000">
          <span>{{ ui.feedback }}</span>
          <v-btn dark flat @click="ui.showFeedback = false">Close</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import playerCard from "./PlayerCard.vue";
import { mapState } from "vuex";
import _ from "underscore";

export default {
  data: function() {
    return {
      team: {
        club: {
          id: "",
          name: "",
        },
        id: "",
        players: [],
        category: "",
        coach: "",
        manager: "",
        memo: "",
      },
      championship: {
        id: "",
        name: "",
      },
      ui: {
        feedback: "",
        showFeedback: false,
        isError: false,
        loading: false,
        isDirty: false,
        showConfirm: false,
        showJerseyError:false
      },
    };
  },
  computed: {
    ...mapState("config", ["identity"]),
  },
  components: {
    playerCard: playerCard,
  },
  methods: {
    reload: function() {},
    loadChampionship: function(id) {
      var me = this;
      me.ui.loading = true;
      this.$api("championships")
        .get({ id: id })
        .then(function(resp) {
          me.championship = resp;
          var bal = 18 - me.team.players.length;
          for (var i = 0; i < bal; i++) {
            me.team.players.push({ number: "", jerseyNo: "" });
          }
        })
        .catch(function() {
          me.ui.feedback = "An error occured while loading championship information";
          me.ui.showFeedback = true;
          me.ui.isError = true;
        })
        .finally(function() {
          me.ui.isDirty = false;
          me.ui.loading = false;
        });
    },
    cancel: function() {
      if (this.ui.isDirty) {
        this.ui.showConfirm = true;
      } else {
        this.$router.push({ name: "team-list", params: { id: this.championship.id } });
      }
    },
    save: function() {
      var me = this;
      var team = JSON.parse(JSON.stringify(this.team));
      team.players = _.filter(team.players, (x) => x && x.number);
      me.ui.feedback = "";
      if (team.players.some((x) => !x.jerseyNo)) {
        me.ui.feedback = "Please specify jersey number for every player";
        me.ui.showFeedback = true;
        me.ui.showJerseyError=true;
        return;
      }
      team.championshipId = this.championship.id;
      var api = this.$api("teams");
      var request = this.team.id ? api.put(team) : api.post(team);
      request
        .then(function() {
          me.showChampList();
        })
        .catch(function(xhr) {
          me.ui.isError = true;
          me.ui.showFeedback = true;
          me.ui.feedback = xhr.responseJSON && xhr.responseJSON.feedback ? xhr.responseJSON.feedback : "An error occured while processing your request";
        });
    },
    showChampList: function() {
      this.$router.push({ name: "team-list", params: { id: this.championship.id } });
    },
    loadTeam: function(id) {
      var me = this;
      me.ui.loading = true;

      this.$api("teams/" + id)
        .get()
        .then(function(resp) {
          me.championship = resp.championship;
          var team = _.omit(resp, "championship");
          team.players = _.map(team.players, function(x) {
            return { number: x.registerNumber, jerseyNo: x.jerseyNo };
          });
          me.team = team;
          var bal = 18 - me.team.players.length;
          for (var i = 0; i < bal; i++) {
            me.team.players.push({ number: "", jerseyNo: "" });
          }
        })
        .catch(function() {})
        .finally(function() {
          me.ui.isDirty = false;
          me.ui.loading = false;
        });
    },
  },
  mounted: function() {
    if (this.$route.params.champ) {
      this.loadChampionship(this.$route.params.champ);
    } else if (this.$route.params.id) {
      this.loadTeam(this.$route.params.id);
    }
  },
  watch: {
    team: {
      deep: true,
      handler: function() {
        this.ui.isDirty = true;
      },
    },
  },
};
</script>

<style></style>
